import { ComposedChart, Line, Area, XAxis, YAxis, ReferenceLine, Tooltip as RechartsTooltip, ResponsiveContainer, CartesianGrid, Legend, Label } from 'recharts';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FreezingCurve = function ({ recipeObj, servingTemp }) {
  const { t } = useTranslation();
  return (
  <Box sx={{ width: '100%', height: 220 }}>
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart margin={{ top: 0, right: 35, left: 5, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={true} horizontal={true} />
        <Area
          type="monotone"
          name="reference"
          data={[
            { ice: 63, temp: [-35, 0] },
            { ice: 65, temp: [-35, 0] },
          ]}
          dataKey="temp"
          xKey="ice"
          yKey="temp"
          stroke="none"
          fill="#ff8282"
          fillOpacity={0.3}
          isAnimationActive={false}
          activeDot={false}
          dot={false}
          connectNulls={true}
        />
        <Area
          type="monotone"
          name="reference"
          data={[
            { ice: 65, temp: [-35, 0] },
            { ice: 67, temp: [-35, 0] },
          ]}
          dataKey="temp"
          xKey="ice"
          yKey="temp"
          stroke="none"
          fill="#ffe082"
          fillOpacity={0.3}
          isAnimationActive={false}
          activeDot={false}
          dot={false}
          connectNulls={true}
        />
        <Area
          type="monotone"
          name="reference"
          data={[
            { ice: 67, temp: [-35, 0] },
            { ice: 75, temp: [-35, 0] },
          ]}
          dataKey="temp"
          xKey="ice"
          yKey="temp"
          stroke="none"
          fill="#aaf082"
          fillOpacity={0.3}
          isAnimationActive={false}
          activeDot={false}
          dot={false}
          connectNulls={true}
        />
        <Area
          type="monotone"
          name="reference"
          data={[
            { ice: 75, temp: [-35, 0] },
            { ice: 77, temp: [-35, 0] },
          ]}
          dataKey="temp"
          xKey="ice"
          yKey="temp"
          stroke="none"
          fill="#ffe082"
          fillOpacity={0.3}
          isAnimationActive={false}
          activeDot={false}
          dot={false}
          connectNulls={true}
        />
        <Area
          type="monotone"
          name="reference"
          data={[
            { ice: 77, temp: [-35, 0] },
            { ice: 80, temp: [-35, 0] },
          ]}
          dataKey="temp"
          xKey="ice"
          yKey="temp"
          stroke="none"
          fill="#ff8282"
          fillOpacity={0.3}
          isAnimationActive={false}
          activeDot={false}
          dot={false}
          connectNulls={true}
        />
        <XAxis
          dataKey="ice"
          type="number"
          domain={[0, 90]}
          ticks={[...Array(19)].map((_, i) => i * 5)}
        >
          <Label value={t('ice_content_percentage')} position="insideBottom" offset={-5} />
        </XAxis>
        <YAxis
          dataKey="temp"
          domain={[-30, 0]}
          ticks={[...Array(7)].map((_, i) => -30 + i * 5)}
          label={{ value: 'T(°C)', angle: -90, position: 'insideLeft' }}
        />
        <Legend
          verticalAlign="top"
          align="right"
          payload={
            [
              ...recipeObj.getGraphData().map((s, i) => ({
                value: s.name,
                type: 'line',
                id: s.name,
                color: s.color || (i === 0 ? "#1976d2" : "#d2691e")
              }))
            ]
          }
        />
        <ReferenceLine
          y={servingTemp}
          stroke="#ff1744"
          strokeDasharray="6 2"
          label={{
            value: `${servingTemp}°C`,
            position: "right",
            fill: "#ff1744",
            fontSize: 12
          }}
        />
        <RechartsTooltip
          content={({ active, payload, label }) => {
            if (!active || !payload || payload.length === 0) return null;
            const filteredPayload = payload.filter(
              entry => entry.name && entry.name !== 'reference'
            );
            if (filteredPayload.length === 0) return null;
            return (
              <Box sx={{ background: '#fff', border: '1px solid #ccc', p: 1 }}>
                <div><b>{label.toFixed && label.toFixed(0)}% Agua congelada</b></div>
                {filteredPayload.map((entry, i) => {
                  const serie = recipeObj.getGraphData().find(s => s.name === entry.name);
                  let tempValue = '';
                  if (serie && serie.data && typeof label !== 'undefined') {
                    const closest = serie.data.reduce((prev, curr) =>
                      Math.abs(curr.ice - label) < Math.abs(prev.ice - label) ? curr : prev
                    );
                    tempValue = closest.temp;
                  } else if (entry.payload && typeof entry.payload.temp !== "undefined") {
                    tempValue = entry.payload.temp;
                  } else if (entry.value !== undefined) {
                    tempValue = entry.value;
                  }
                  return (
                    <div key={i} style={{ color: entry.color }}>
                      {entry.name}: {tempValue}°C
                    </div>
                  );
                })}
              </Box>
            );
          }}
          labelFormatter={l => `${l}%`}
        />
        {recipeObj.getGraphData().map((s, i) => (
          <Line
            key={s.name}
            data={s.data}
            dataKey="temp"
            name={s.name}
            activeDot={false}
            dot={false}
            stroke={s.color || (i === 0 ? "#1976d2" : "#d2691e")}
            isAnimationActive={false}
          />
        ))}
      </ComposedChart>
    </ResponsiveContainer>
  </Box>
)};

export default FreezingCurve;
